import type { MaskOptions } from '@react-input/mask';

export const PHONE_MASK_OPTIONS: MaskOptions = {
  mask: '(___) ___-____',
  replacement: { _: /\d/ },
};

export const DOB_MASK_OPTIONS: MaskOptions = {
  mask: '__-__-____',
  replacement: { _: /\d/ },
};

export const SSN_MASK_OPTIONS: MaskOptions = {
  mask: '___-__-____',
  replacement: { _: /\d/ },
};

export const stripDigits = (value: string): string => value.replace(/\D/g, '');

export const formatDob = (value: string): string => {
  const digits = stripDigits(value).slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`;
};

export const dobMaskToBackend = (masked: string): string => {
  const digits = stripDigits(masked);
  if (digits.length !== 8) return masked;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const formatSsn = (value: string): string => stripDigits(value).slice(0, 9);

export const formatPhoneDigits = (value: string): string => stripDigits(value).replace(/^1/, '').slice(0, 10);

export const formatDisplayPhone = (value: string): string => {
  const digits = formatPhoneDigits(value);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
